import axios from 'axios';

export default class AirportSettings {

	statuses() {
		return axios.get(`${window.configuration.activeFlights.endpoints.statuses}`).then(res => res);
	}
	
	gates() {
		return axios.get(`${window.configuration.activeFlights.endpoints.gates}`).then(res => res);
	}
	
	claims() {
		return axios.get(`${window.configuration.activeFlights.endpoints.claims}`).then(res => res);
  }
  
}